/* SphereStandouts Custom Theme v2.0.0 — Single JS file */


/* --- Collection Sort --- */
function initCollectionSort() {
  var select = document.querySelector('[data-sort-select]');
  if (!select) return;
  select.addEventListener('change', function() {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });
}


/* --- Thumbnail Scroll Arrows --- */
function initThumbScroll() {
  var wrap = document.querySelector('.product-gallery__thumbs-wrap');
  var track = document.querySelector('[data-thumbs-track]');
  if (!wrap || !track) return;
  var prevBtn = wrap.querySelector('[data-thumbs-prev]');
  var nextBtn = wrap.querySelector('[data-thumbs-next]');
  function updateState() {
    var hasOverflow = track.scrollWidth > track.clientWidth + 2;
    wrap.classList.toggle('product-gallery__thumbs-wrap--has-overflow', hasOverflow);
    if (hasOverflow) {
      var atStart = track.scrollLeft < 5;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      if (prevBtn) prevBtn.style.display = atStart ? 'none' : 'flex';
      if (nextBtn) nextBtn.style.display = atEnd ? 'none' : 'flex';
      wrap.classList.remove('product-gallery__thumbs-wrap--scrolled-end', 'product-gallery__thumbs-wrap--scrolled-mid');
      if (atEnd) wrap.classList.add('product-gallery__thumbs-wrap--scrolled-end');
      else if (!atStart) wrap.classList.add('product-gallery__thumbs-wrap--scrolled-mid');
    }
  }
  if (prevBtn) prevBtn.addEventListener('click', function() { track.scrollBy({ left: -200, behavior: 'smooth' }); });
  if (nextBtn) nextBtn.addEventListener('click', function() { track.scrollBy({ left: 200, behavior: 'smooth' }); });
  track.addEventListener('scroll', updateState);
  window.addEventListener('resize', updateState);
  updateState();
  window.addEventListener('load', updateState);
  setTimeout(updateState, 500);
}

/* --- Gallery Swipe + Dots + Counter --- */
function initGallerySwipe() {
  var mainEl = document.querySelector('[data-gallery-main]');
  var counterEl = document.querySelector('[data-gallery-counter]');
  var dotsContainer = document.querySelector('[data-gallery-dots]');
  if (!mainEl) return;
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var dots = dotsContainer ? dotsContainer.querySelectorAll('.product-gallery__dot') : [];
  var images = [];
  thumbs.forEach(function(t) { images.push(t.getAttribute('data-gallery-thumb')); });
  if (images.length < 2) return;

  var currentIndex = 0;
  var mainImg = mainEl.querySelector('img');

  function goToImage(idx) {
    if (idx < 0) idx = 0;
    if (idx >= images.length) idx = images.length - 1;
    if (idx === currentIndex) return;
    currentIndex = idx;
    mainImg.src = images[idx];
    /* srcset preserved */
    if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + images.length;
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
    thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
    if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  // Expose gallery navigation for variant selector
  window.__goToImage = goToImage;
  window.__galleryImages = images;

  /* Dot click */
  if (dotsContainer) {
    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.product-gallery__dot');
      if (dot) goToImage(parseInt(dot.getAttribute('data-dot-index'), 10));
    });
  }

  /* Touch swipe on main image */
  var startX = 0, startY = 0, distX = 0, tracking = false;
  mainEl.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    distX = 0;
    tracking = true;
  }, { passive: true });

  mainEl.addEventListener('touchmove', function(e) {
    if (!tracking) return;
    distX = e.touches[0].clientX - startX;
    var distY = e.touches[0].clientY - startY;
    if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > 10) {
      e.preventDefault();
    }
  }, { passive: false });

  mainEl.addEventListener('touchend', function() {
    if (!tracking) return;
    tracking = false;
    if (Math.abs(distX) > 40) {
      if (distX < 0) goToImage(currentIndex + 1);
      else goToImage(currentIndex - 1);
    }
  }, { passive: true });

  /* Sync when thumb is clicked */
  thumbs.forEach(function(t, i) {
    t.addEventListener('click', function() { goToImage(i); });
  });
}

/* --- Smart Color Swatches --- */
function initColorSwatches() {
  var base = {
    'red':'#cc0000','gold':'#d4a843','silver':'#c0c0c0','black':'#1a1a1a',
    'blue':'#4169e1','green':'#228b22','yellow':'#ffd700','white':'#f5f5f5',
    'pink':'#ff69b4','purple':'#7b2d8e','brown':'#8b4513','grey':'#888',
    'gray':'#888','rose':'#e8a0bf','navy':'#001f3f','beige':'#f5f5dc',
    'bordeaux':'#800020','coffee':'#6f4e37','marron':'#800000',
    'amethyst':'#9966cc','violet':'#8a2be2','aventurine':'#568203',
    'lapis':'#26619c','onyx':'#0f0f0f','obsidian':'#1a1a2e',
    'agate':'#b22222','tiger':'#b8860b','opalite':'#add8e6',
    'quartz':'#f7cac9','ocean':'#006994','lake':'#4682b4',
    'silvery':'#c0c0c0','dark':'#444','light':'#ccc',
    'crimson':'#dc143c','teal':'#008080','coral':'#ff7f50',
    'amber':'#ffbf00','ivory':'#fffff0'
  };
  function resolve(name) {
    var lower = name.toLowerCase().trim();
    /* direct match */
    if (base[lower]) return base[lower];
    /* split on " and ", "/", then find color words */
    var parts = lower.replace(/ and /g,'|').replace(/\//g,'|').split('|');
    var found = [];
    parts.forEach(function(p) {
      p.trim().split(' ').forEach(function(w) {
        if (base[w] && found.indexOf(base[w]) === -1) found.push(base[w]);
      });
    });
    if (found.length === 0) return '#ccc';
    if (found.length === 1) return found[0];
    return 'linear-gradient(135deg,' + found[0] + ' 50%,' + found[1] + ' 50%)';
  }
  document.querySelectorAll('.variant-selector__swatch').forEach(function(el) {
    var t = el.getAttribute('title');
    if (!t) return;
    var bg = resolve(t);
    if (bg.indexOf('gradient') >= 0) {
      el.style.background = bg;
    } else {
      el.style.backgroundColor = bg;
    }
  });
}


/* --- Sticky Add to Cart --- */
function initStickyATC() {
  var bar = document.querySelector('[data-sticky-atc]');
  var btn = document.querySelector('[data-sticky-atc-btn]');
  var origBtn = document.querySelector('[data-add-to-cart]');
  if (!bar || !btn || !origBtn) return;

  /* Show/hide based on original button visibility */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
      } else {
        bar.style.display = '';
        bar.classList.add('is-visible');
      }
    });
  }, { threshold: 0, rootMargin: '0px' });

  observer.observe(origBtn);

  /* Click: submit the main form */
  btn.addEventListener('click', function() {
    if (btn.disabled) return;
    origBtn.click();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initSearchOverlay();
  initMegaMenu();
  initMobileAccordion();
  initProductGallery();
  initVariantSelector();
  initCollectionSort();
  initThumbScroll();
  initGallerySwipe();
  initColorSwatches();
  initStickyATC();
  initQuantitySelector();
  initCartDrawer();
  initQuickAdd();
  initBundlePricing();
});

/* --- Mobile Menu --- */
function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (!toggle || !drawer) return;

  const overlay = drawer.querySelector('[data-mobile-overlay]');
  const close = drawer.querySelector('[data-mobile-close]');

  toggle.addEventListener('click', () => {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    toggle.setAttribute('aria-expanded', 'true');
  });

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    toggle.setAttribute('aria-expanded', 'false');
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (close) close.addEventListener('click', closeDrawer);

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
}

/* --- Search Overlay --- */
function initSearchOverlay() {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = searchOverlay ? searchOverlay.querySelector('input[type="search"]') : null;

  if (!searchToggle || !searchOverlay) return;

  searchToggle.addEventListener('click', (e) => {
    e.preventDefault();
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 100);
    }
  });

  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // Close on overlay click (but not on form click)
  searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) {
      closeSearch();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });
}

/* --- Mega Menu (Desktop) --- */
function initMegaMenu() {
  const megaWrap = document.querySelector('[data-mega-menu]');
  if (!megaWrap) return;

  const toggle = megaWrap.querySelector('[data-mega-toggle]');
  const panel = megaWrap.querySelector('[data-mega-panel]');
  if (!toggle || !panel) return;

  // Toggle on click
  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    const isOpen = panel.classList.contains('is-open');
    if (isOpen) {
      closeMega();
    } else {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  // Open on hover (desktop only)
  megaWrap.addEventListener('mouseenter', () => {
    if (window.innerWidth >= 990) {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  megaWrap.addEventListener('mouseleave', () => {
    if (window.innerWidth >= 990) {
      closeMega();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      closeMega();
      toggle.focus();
    }
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!megaWrap.contains(e.target) && panel.classList.contains('is-open')) {
      closeMega();
    }
  });

  function closeMega() {
    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }
}

/* --- Mobile Accordion (Drawer) --- */
function initMobileAccordion() {
  const accordions = document.querySelectorAll('[data-mobile-accordion]');
  accordions.forEach(accordion => {
    const toggle = accordion.querySelector('[data-accordion-toggle]');
    const panel = accordion.querySelector('[data-accordion-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const isOpen = panel.classList.contains('is-open');
      if (isOpen) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        panel.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* --- Product Gallery --- */
function initProductGallery() { if (window.innerWidth < 750) return; // mobile handled by initGallerySwipe if (window.innerWidth < 750) return; // mobile handled by initGallerySwipe if (window.innerWidth < 750) return; // mobile handled by initGallerySwipe if (window.innerWidth < 750) return; // mobile handled by initGallerySwipe if (window.innerWidth < 750) return; // mobile handled by initGallerySwipe if (window.innerWidth < 750) return; // mobile handled by initGallerySwipe return; // handled by initGallerySwipe return; // handled by initGallerySwipe return; // handled by initGallerySwipe
  const main = document.querySelector('[data-gallery-main]');
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');
  if (!main || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.galleryThumb;
      const mainImg = main.querySelector('img');
      if (mainImg && src) {
        mainImg.src = src;
        /* srcset preserved */
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  });
}

/* --- Variant Selector --- */
function initVariantSelector() {
  const form = document.querySelector('[data-product-form]');
  const optionButtons = document.querySelectorAll('[data-variant-option]');
  const variantInput = document.querySelector('[data-variant-id]');
  const priceEl = document.querySelector('[data-product-price]');
  const comparePriceEl = document.querySelector('[data-product-compare-price]');
  const saveBadge = document.querySelector('.product-info__save-badge');
  const galleryBadge = document.querySelector('.product-gallery__badge');

  if (!form || !optionButtons.length) return;

  const variantsJson = document.querySelector('[data-product-variants]');
  if (!variantsJson) return;

  let variants;
  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (e) {
    console.error('Failed to parse variants JSON', e);
    return;
  }

  function getSelectedOptions() {
    const selected = [];
    document.querySelectorAll('[data-option-group]').forEach(g => {
      const active = g.querySelector('.is-selected');
      if (active) selected.push(active.dataset.variantOption.trim());
    });
    return selected;
  }

  function findVariant(selected) {
    const currentId = Number(variantInput && variantInput.value) || null;
    const cur = currentId ? variants.find(v => v.id === currentId) : null;
    return variants.find(v =>
      v.options.every((opt, i) =>
        i < selected.length
          ? opt.trim() === selected[i].trim()
          : (cur ? opt.trim() === cur.options[i].trim() : true)
      )
    );
  }

  function updateVariant(variant) {
    if (!variant) return;

    // Update hidden input
    if (variantInput) variantInput.value = variant.id;

    // Update price
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Update compare price and save badge
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
        const savePercent = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        if (saveBadge) {
          saveBadge.textContent = 'Save ' + savePercent + '%';
          saveBadge.style.display = '';
        }
        if (galleryBadge) {
          galleryBadge.textContent = '-' + savePercent + '%';
          galleryBadge.style.display = '';
        }
      } else {
        comparePriceEl.style.display = 'none';
        if (saveBadge) saveBadge.style.display = 'none';
        if (galleryBadge) galleryBadge.style.display = 'none';
      }
    }

    // Update gallery main image
    if (variant.featured_image) {
      var varSrc = variant.featured_image.src.split('?')[0];
      var imgs = window.__galleryImages || [];
      var matchIdx = -1;
      for (var gi = 0; gi < imgs.length; gi++) {
        if (imgs[gi].split('?')[0] === varSrc) { matchIdx = gi; break; }
      }
      console.log('[VARIANT DEBUG] matchIdx=', matchIdx, 'goToImage=', !!window.__goToImage, 'imgs.length=', imgs.length, 'varSrc=', varSrc);
      if (matchIdx >= 0 && window.__goToImage) {
        window.__goToImage(matchIdx);
      } else {
        console.log('[VARIANT DEBUG] FALLBACK - direct src change');
        var mi = document.querySelector('[data-gallery-main] img');
        if (mi) mi.src = variant.featured_image.src;
      }
    }

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Update add to cart button
    const addBtn = document.querySelector('[data-add-to-cart]');
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> ' + (addBtn.dataset.addText || 'Add to Cart');
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      }
    }
  }

  // Attach click handlers
  optionButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const group = this.closest('[data-option-group]');
      if (group) {
        group.querySelectorAll('[data-variant-option]').forEach(o => o.classList.remove('is-selected'));
      }
      this.classList.add('is-selected');

      // Update selected label
      if (group) {
        const selectedLabel = group.querySelector('[data-option-selected]');
        if (selectedLabel) {
          selectedLabel.textContent = this.dataset.variantOption;
        }
      }

      const selected = getSelectedOptions();
      const variant = findVariant(selected);
      updateVariant(variant);
    });
  });

  // Select initial variant from URL
  const urlParams = new URLSearchParams(window.location.search);
  const initialVariantId = urlParams.get('variant');
  if (initialVariantId) {
    const variant = variants.find(v => String(v.id) === String(initialVariantId));
    if (variant) {
      variant.options.forEach((opt, i) => {
        const group = document.querySelector('[data-option-group="' + i + '"]');
        if (group) {
          const btns = group.querySelectorAll('[data-variant-option]');
          btns.forEach(b => {
            b.classList.remove('is-selected');
            if (b.dataset.variantOption.trim() === opt.trim()) {
              b.classList.add('is-selected');
              const selectedLabel = group.querySelector('[data-option-selected]');
              if (selectedLabel) selectedLabel.textContent = opt;
            }
          });
        }
      });
    }
  }
}

/* --- Quantity Selector --- */
function initQuantitySelector() {
  document.querySelectorAll('[data-quantity]').forEach(container => {
    const minus = container.querySelector('[data-quantity-minus]');
    const plus = container.querySelector('[data-quantity-plus]');
    const input = container.querySelector('[data-quantity-input]');
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });

    plus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });
}

/* --- Cart Drawer --- */
function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer) return;

  const close = drawer.querySelector('[data-cart-close]');
  if (close) close.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('[data-cart-toggle]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });
}

function openCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (drawer) drawer.classList.add('is-open');
  if (overlay) overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('is-open');
  document.body.style.overflow = '';
}

/* --- Quick Add --- */
function initQuickAdd() {
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.quickAdd;
      if (!variantId) return;

      const originalHTML = btn.innerHTML;
      btn.innerHTML = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        });

        if (res.ok) {
          btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> Added!';
          updateCartCount();
refreshCartDrawer();
          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 1500);
        } else {
          btn.innerHTML = 'Error';
          setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 1500);
        }
      } catch {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }
    });
  });
}

/* --- Add to Cart (product page) --- */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-product-form]');
  if (!form) return;
  e.preventDefault();

  const addBtn = form.querySelector('[data-add-to-cart]');
  if (addBtn) {
    addBtn.textContent = 'Adding...';
    addBtn.disabled = true;
  }

  try {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (res.ok) {
      if (addBtn) addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      updateCartCount();
      openCartDrawer();
      await refreshCartDrawer();
      setTimeout(() => {
        if (addBtn) {
          addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> ' + (addBtn.dataset.addText || 'Add to Cart');
          addBtn.disabled = false;
        }
      }, 2000);
    } else {
      const data = await res.json();
      if (addBtn) {
        addBtn.textContent = data.description || 'Error';
        setTimeout(() => {
          addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> ' + (addBtn.dataset.addText || 'Add to Cart');
          addBtn.disabled = false;
        }, 2000);
      }
    }
  } catch {
    if (addBtn) {
      addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart';
      addBtn.disabled = false;
    }
  }
});

/* --- Cart Helpers --- */
async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  } catch { /* silent */ }
}

async function refreshCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const items = document.querySelector('[data-cart-items]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    const empty = document.querySelector('[data-cart-empty]');

    if (items) {
      if (cart.items.length === 0) {
        items.innerHTML = '';
        if (empty) empty.style.display = '';
      } else {
        if (empty) empty.style.display = 'none';
        items.innerHTML = cart.items.map(item => `
          <div class="cart-item">
            <div class="cart-item__image">
              <a href="${item.url}"><img src="${item.image}" alt="${item.title}" loading="lazy" width="80" height="80"></a>
            </div>
            <div class="cart-item__details">
              <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
              ${item.variant_title ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}${item.handle === 'linked-initials-necklace' && item.properties && Object.keys(item.properties).length > 0 ? Object.entries(item.properties).filter(([k,v]) => v !== '').map(([k,v]) => `<div class="cart-item__variant" style="font-size:12px;">${k}: ${v}</div>`).join('') : ''}
              <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
              <div style="display:flex;align-items:center;gap:8px;margin-top:6px;">
                <button data-cart-change="${item.key}" data-cart-qty="${item.quantity - 1}" style="background:none;border:1px solid var(--color-border);border-radius:4px;width:28px;height:28px;cursor:pointer;color:var(--color-text-primary);display:flex;align-items:center;justify-content:center;">-</button>
                <span style="min-width:20px;text-align:center;">${item.quantity}</span>
                <button data-cart-change="${item.key}" data-cart-qty="${item.quantity + 1}" style="background:none;border:1px solid var(--color-border);border-radius:4px;width:28px;height:28px;cursor:pointer;color:var(--color-text-primary);display:flex;align-items:center;justify-content:center;">+</button>
                <button data-cart-change="${item.key}" data-cart-qty="0" style="background:none;border:none;color:var(--color-sale);cursor:pointer;margin-left:auto;font-size:0.8rem;font-family:var(--font-body);">Remove</button>
              </div>
            </div>
          </div>
        `).join('');
      }
    }

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  } catch { /* silent */ }
}

async function changeCartItem(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await updateCartCount();
    await refreshCartDrawer();
  } catch { /* silent */ }
}

/* Cart button event delegation */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-cart-change]');
  if (btn) {
    changeCartItem(btn.dataset.cartChange, parseInt(btn.dataset.cartQty));
  }
});

/* --- Format Money --- */
function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2);
  const currency = window.__shopCurrency || '$';
  return `${currency}${amount}`;
}

/* --- Bundle Pricing --- */
function initBundlePricing() {
  const container = document.querySelector('[data-bundle-pricing]');
  if (!container) return;

  const unitPrice = parseInt(container.dataset.unitPrice, 10);
  const discounts = { 1: 0, 2: 15, 3: 20 };
  const options = container.querySelectorAll('[data-bundle-qty]');
  const qtyInput = document.querySelector('[data-quantity-input]');

  // Calculate and display prices for each tier
  options.forEach(opt => {
    const qty = parseInt(opt.dataset.bundleQty, 10);
    const discount = discounts[qty] || 0;
    const discountedUnit = Math.round(unitPrice * (1 - discount / 100));
    const total = discountedUnit * qty;
    const original = unitPrice * qty;

    const perUnit = opt.querySelector('[data-bundle-per-unit]');
    const totalEl = opt.querySelector('[data-bundle-total]');
    const originalEl = opt.querySelector('[data-bundle-original]');

    if (perUnit) perUnit.textContent = formatMoney(discountedUnit);
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (originalEl && discount > 0) originalEl.textContent = formatMoney(original);

    opt.addEventListener('click', () => {
      options.forEach(o => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change'));
      }
    });
  });
}

/* --- Init cart count on load --- */
updateCartCount();
